<template>
  <v-card-actions class="pa-0" v-if="$store.getters.isClubRole">
    <v-spacer></v-spacer>
    <div v-if="item.canEdit">
      <v-layout row>
        <v-btn icon flat small @click="verPago" class="pa-0 ma-0 mt-1">
          <v-tooltip bottom>
            <v-badge dot overlap left color="red" slot="activator">
              <span slot="badge" v-if="item.tieneNotificaciones">!</span>
              <v-icon color="blue">edit</v-icon>
            </v-badge>
            <span>Ver / Editar</span>
          </v-tooltip>
        </v-btn>
        <v-btn v-if="item.canDelete" icon flat small @click="deletePago" class="pa-0 ma-0 mt-1">
          <v-tooltip bottom>
            <v-icon slot="activator" color="red">delete</v-icon>
            <span>Borrar</span>
          </v-tooltip>
        </v-btn>
      </v-layout>
    </div>
    <div v-else>
      <v-btn icon flat small @click="verPago" class="pa-0 ma-0 mt-1">
        <v-tooltip bottom>
            <v-badge dot overlap left color="red" slot="activator">
              <span slot="badge" v-if="item.tieneNotificaciones">!</span>
              <v-icon color="blue">visibility</v-icon>
            </v-badge>
          <span>Ver</span>
        </v-tooltip>
      </v-btn>
    </div>
    <v-spacer></v-spacer>
  </v-card-actions>

  <v-card-actions class="pa-0" v-else>
    <v-spacer></v-spacer>
    <v-btn icon flat small @click="verPago" class="pa-0 ma-0 mt-1">
      <v-tooltip bottom>
            <v-badge dot overlap left color="red" slot="activator">
              <span slot="badge" v-if="item.tieneNotificaciones">!</span>
              <v-icon color="blue">visibility</v-icon>
            </v-badge>
        <span>Ver</span>
      </v-tooltip>
    </v-btn>

    <div v-if="$store.getters.isSafRole && item.canEdit">
      <v-layout row>
        <v-btn icon flat small @click="aprobarPago" class="pa-0 ma-0 mt-1">
          <v-tooltip bottom>
            <v-icon slot="activator" color="green">thumb_up</v-icon>
            <span>Aprobar</span>
          </v-tooltip>
        </v-btn>
        <v-btn i icon flat small @click="rechazarPago" class="pa-0 ma-0 mt-1">
          <v-tooltip bottom>
            <v-icon slot="activator" color="red">thumb_down</v-icon>
            <span>Rechazar</span>
          </v-tooltip>
        </v-btn>
      </v-layout>
    </div>
    <v-spacer></v-spacer>
  </v-card-actions>
</template>

<script>
export default {
  props: {
    item: Object
  },

  methods: {
    aprobarPago () {
      const pagosTable = this.$parent.$parent
      pagosTable.$emit('aprobarPago', this.item.pk)
    },
    rechazarPago () {
      const pagosTable = this.$parent.$parent
      pagosTable.$emit('rechazarPago', this.item.pk)
    },
    verPago () {
      const pagosTable = this.$parent.$parent
      pagosTable.$emit('viewPago', this.item.pk)
    },
    deletePago () {
      const fullname = `${this.item.jugador.firstName} ${this.item.jugador.lastName}`

      const pagosTable = this.$parent.$parent
      pagosTable.$emit('borrarPago', this.item.pk, fullname)
    }
  }
}
</script>
